import './UserControls.scss';
import { AsyncStateStatus } from '@sonar-software/xuder';
import { Button } from 'antd';
import { createAsyncSelectors } from '@lib/selectors';
import { ADMIN_DASHBOARD_COPY, COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { LockOutlined, UnlockOutlined } from '@ant-design/icons';
import React, { useCallback } from 'react';
import { useAction, useAppNotifications, useAsyncProcessing } from '@hooks';
const selectors = createAsyncSelectors((state) => state.core.users.admin.patch);
export const UserLockStateToggleButton = ({ onChange = () => null, shardName, user, userIsLocked }) => {
    const { errorNotification } = useAppNotifications();
    const patchUserAdmin = useAction(coreActions.requestPatchCoreUsersAdmin);
    const resetPatchUserAdmin = useAction(coreActions.resetPatchCoreUsersAdmin);
    const processPatch = useAsyncProcessing({
        resetAction: resetPatchUserAdmin,
        stateSelector: selectors.state,
        statusHandlers: {
            [AsyncStateStatus.Received]: onChange,
            [AsyncStateStatus.Errored]: () => errorNotification(COPY_GENERIC.CONTACT_SUPPORT),
            [AsyncStateStatus.Failed]: () => errorNotification(COPY_GENERIC.CONTACT_SUPPORT)
        }
    });
    const onClick = useCallback(() => {
        processPatch.watchNextCall();
        patchUserAdmin({
            isLocked: !userIsLocked,
            shardName,
            userId: user.id
        });
    }, [processPatch, patchUserAdmin, userIsLocked, shardName, user.id]);
    return (React.createElement("div", { style: { display: 'inline-block' } },
        userIsLocked &&
            React.createElement(Button, { className: 'unlock-user-button', danger: true, icon: React.createElement(UnlockOutlined, null), loading: processPatch.state.isProcessing, onClick: onClick }, ADMIN_DASHBOARD_COPY.UNLOCK),
        !userIsLocked &&
            React.createElement(Button, { className: 'lock-user-button', icon: React.createElement(LockOutlined, null), loading: processPatch.state.isProcessing, onClick: onClick }, ADMIN_DASHBOARD_COPY.LOCK)));
};
